/**
 * 获取用户的收藏夹列表。
 *
 * @param userId - 指定用户的 ID。
 * @returns 返回用户或默认用户的收藏夹列表的 Promise。
 *
 * @remarks
 * 该函数发送请求以获取用户的收藏夹列表。
 * 请注意，如果发生请求失败，错误将不会在此处捕获，而是被传递给调用方处理。
 *
 * @example
 * ```typescript
 * // 获取默认用户的收藏夹列表
 * const defaultUserCollections = await fetchCollectionList();
 * console.log(defaultUserCollections); // 返回默认用户的收藏夹列表
 *
 * // 获取指定用户的收藏夹列表
 * const specificUserCollections = await fetchCollectionList(123);
 * console.log(specificUserCollections); // 返回指定用户的收藏夹列表
 * ```
 */
export async function fetchCollectionList(
  userId: number
): Promise<FavoriteFolder[]> {
  return http
    .get<{
      list: Collection[]
    }>('/v1/favorite/get_favorite_list', {
      user_id: userId
    })
    .then((res) => res.data.list)
    .catch(() => [])
}
